export default {
    manage_cameraManagement: "Camera Management",
    manage_cameraManagement_title: "Camera Management",
    manage_cameraManagement_recordId: "Record Id",
    manage_cameraManagement_imei: "IMEI",
    manage_cameraManagement_esn: "ESN",
    manage_cameraManagement_pairedUnit: "Paired Unit",
    manage_cameraManagement_label: "Label",
    manage_cameraManagement_unpaired: "Unpaired",
    manage_cameraManagement_editCameraPairing: "Edit Camera Pairing",
    manage_cameraManagement_showUnpairedOnly: "Show unpaired only",
    manage_cameraManagement_editCamera: "Edit",
    manage_cameraManagement_cameraSetup: "Camera Setup",
    manage_cameraManagement_sdCardError: "SD card error",
    manage_cameraManagement_warnings: "Warnings",
    manage_cameraManagement_bulk_camera_config: "Bulk Camera Config",
    manage_cameraManagement_device_model: "Device Model",
    manage_cameraManagement_4K: "VidFleet AI+",
    manage_cameraManagement_360: "VidFleet 1",
    manage_cameraManagement_same_device_model: "The device model of the cameras must be the same",
    manage_cameraManagement_cameras_must_be_vidfleet: "Cameras must be VidFleet",
    manage_cameraManagement_camara_as_gps: "Camera as GPS",
    manage_cameraManagement_search_by_label_imei_esn: "Search by Label, Paired Unit or ESN",
};